import { render, staticRenderFns } from "./InvoiceAdd.vue?vue&type=template&id=0063aa64&"
import script from "./InvoiceAdd.vue?vue&type=script&lang=js&"
export * from "./InvoiceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports